/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import { XSS } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/sanitize.js';
/**
 * Search utility to sanitize `window.location.search`.
 * @param {String} search search word
 */
export const sanitizeSearch = (searchWord) => {
    const goAndSearch = (search) => {
        window.location.replace(`${window.location.origin}${window.location.pathname}${search}`);
    };
    if (XSS.is(window.location.search)) {
        goAndSearch(window.location.search.replace(/(query=).*(&|$)/, 'query='));
    }
    else if (XSS.hasChars(searchWord)) {
        goAndSearch(window.location.search.replace(/(query=).*(&|$)/, `query=${XSS.sanitize(searchWord)}`));
    }
};
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const searchWord = new URLSearchParams(window.location.search).has('query') ? new URLSearchParams(window.location.search).get('query').replace(/\+/g, ' ') : '';
//# sourceMappingURL=search.js.map